// @ts-nocheck

import debugLib from 'debug';
import * as R from 'ramda';
import { SNAP_MACHINE_NAME } from '../../../../shared/constants/adPartnerConstants';
import { GET_AD_ACCOUNT_STATUS } from '../actions/SANPartnerActions';
import { GET_ACCOUNTS } from '../actions/SnapActions';
import { reducerWrapper } from '../support/utils';
import type { SnapReducer } from '../types/adPartnerTypes';
const debug = debugLib('SnapReducer');
export const INIT_STATE = {
  accounts: [],
  adAccountStatus: {},
  loading: false,
};

function Handler(state: SnapReducer = INIT_STATE, action) {
  debug('Receive action type', action.type);

  switch (action.type) {
    case GET_ACCOUNTS.response:
      const { accounts } = action.data;
      return R.merge(state, {
        accounts,
        loading: false,
      });

    case GET_AD_ACCOUNT_STATUS.response:
      const adAccountStatus = R.path([SNAP_MACHINE_NAME], action.data) || {};
      return R.merge(state, {
        adAccountStatus,
      });

    default:
      return state;
  }
}

const Snap = reducerWrapper(INIT_STATE, Handler, {
  request: [GET_ACCOUNTS, GET_AD_ACCOUNT_STATUS],
  error: [GET_ACCOUNTS, GET_AD_ACCOUNT_STATUS],
  resetOn: ['APP_CHANGE'],
});
export default Snap;
